import { useAuthStore } from "./authentication";
import { useAnswersStore } from "./answers";
import { useCartStore } from "./cart";
import { useCheckInStore } from "./checkin";
import { useLanguageStore } from "./language";
import { usePartnerStore } from "./partner";
import { usePoliciesStore } from "./policies";
import { useProductsStore } from "./products";
import { useQuestionsStore } from "./questions";
import { useSimpleSatStore } from "./simple-sat";
import { useStepStore } from "./steps";
import { useSurveyStore } from "./survey";
import { useTitleStore } from "./title";
import { useUserChoicesStore } from "./user-choices";
import { useConsumerStore } from "./consumer";

export const resetStores = () => {
  useAuthStore.getState().clearAuth();
  useAnswersStore.getState().clearAnswers();
  useCartStore.getState().clearCart();
  useCheckInStore.getState().clearCheckInData();
  useLanguageStore.getState().clearLanguage();
  usePartnerStore.getState().clearPartner();
  usePoliciesStore.getState().clearPolicies();
  useProductsStore.getState().clearProductsStore();
  useQuestionsStore.getState().clearQuestions();
  useSimpleSatStore.getState().clear();
  useStepStore.getState().clearSteps();
  useSurveyStore.getState().clearSurvey();
  useTitleStore.getState().clearTitleStore();
  useUserChoicesStore.getState().clearChoices();
  useConsumerStore.getState().clearConsumer();
};

export const clearCache = () => {
  useAnswersStore.getState().clearAnswers();
  useUserChoicesStore.getState().clearChoices();
  useConsumerStore.getState().clearConsumer();
};
